import { UrlsPermissions } from './urls.permissions';
import { UrlsRoles } from './urls.roles';

export const urlsMappings = {
  [UrlsPermissions.GET_URLS]: [UrlsRoles.VIEWER],
  [UrlsPermissions.PERSIST_URL]: [UrlsRoles.PERSISTER],
  [UrlsPermissions.DELETE_URL]: [UrlsRoles.DELETER],
};
